module.exports = __webpack_public_path__ + "img/45.0b82d54a.png";